import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

/**
 * Batch V1.4 #7 — shared hook for /api/settings/<key>-defaults CRUD.
 *
 * Handles fetch, PATCH, reset. Each defaults page keeps its own
 * form-shape logic (mapping between server booleans/strings and the
 * page's control state) but delegates the transport concerns here.
 */
export function useDefault(key) {
  const base = `/settings/${key}-defaults`;
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(base);
      setValue(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }, [base]);

  useEffect(() => { reload(); }, [reload]);

  const save = useCallback(async (patch) => {
    const { data } = await api.patch(base, patch);
    setValue(data);
    return data;
  }, [base]);

  const reset = useCallback(async () => {
    const { data } = await api.post(`${base}/reset`);
    setValue(data);
    return data;
  }, [base]);

  return { value, loading, save, reset, reload };
}
